<template lang="pug">
div
  app-divider.container-input(label="Custas processuais", :showBorder="true")
  .custas
    el-checkbox-group(v-model="custasVtn" @change="handleChange")
      el-row
        el-checkbox(
          v-for='custa in tiposCustas'
          v-if="custa.grupo === 'PROCESSUAIS'",
          :checked="selecionado(custa.id)",
          :label='custa',
          :key='custa.id'
        ).checkbox
          .label {{custa.descricao}}
  app-divider.container-input(label="Custas agrárias", :showBorder="true")
  .custas
    .input-custas(v-for="custa in tiposCustas.filter(item => item.grupo === 'AGRARIAS')")
      span.span-item {{ custa.descricao }}
      el-input-number.input-item(:value="getCustaValue(custa.id)" @change="handleChangeAgraria($event, custa)", :min="0", size="small")

</template>
<script>
import AppDivider from '@/components/AppDivider'
import _ from 'lodash'

export default {
  components: {
    AppDivider
  },

  data () {
    return {}
  },

  computed: {
    custasVtn () {
      return this.$store.state.vtn.dadosVtn.custasVtn
    },

    tiposCustas () {
      return this.$store.state.vtn.tiposCustas
    }
  },

  methods: {
    handleChange (value) {
      const custa = value.target._value
      this.$store.commit('vtn/SET_CUSTA', { tipoCusta: { ...custa } })
    },

    selecionado (id) {
      return !!this.$store.state.vtn.dadosVtn.custasVtn.find(custa => custa.tipoCusta.id === id)
    },

    getCustaValue (id) {
      const custa = _.find(this.custasVtn, item => item.tipoCusta.id === id)
      return custa ? custa.quantidade : 0
    },

    handleChangeAgraria (quantidade, custa) {
      const custaAux = { quantidade, tipoCusta: { ...custa } }
      this.$store.commit('vtn/SET_CUSTA_AGRARIA', { ...custaAux })
    }
  }
}
</script>

<style lang="scss" scoped>
.custas {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
}

.label {
  font-size: 16px;
}

.checkbox {
  white-space: normal;
  display: block;
  margin: 5px;
}

.input-custas{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 50%;
  padding: 10px
}

@media screen and (max-width: 1200px) {
  .input-custas{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/financeiro/vtn/CustasVtn.vue